import * as ACTION_TYPES from '../types';

let initialState = {
    budgetList: [],
    budget: {},
    totalItems: 0,
    loading: false
}

export default (state = initialState, action) => {
    switch (action.type) {
        case ACTION_TYPES.GET_BUDGETS:
            return { ...state, budgetList: action.data, totalItems: action.totalItems || 0 };
        case ACTION_TYPES.DELETE_BUDGET:
            let newList = state.budgetList.filter(budget => budget._id !== action.id);
            return { ...state, budgetList: newList };
        case ACTION_TYPES.GET_BUDGET_BY_ID:
            return { ...state, budget: action.data };
        case ACTION_TYPES.REQUEST:
            return { ...state, loading: true };
        case ACTION_TYPES.DONE:
            return { ...state, loading: false };
        case ACTION_TYPES.RESET_BUDGETS:
            return { ...state, budgetList: [], budget: {}, totalItems: 0 }
        default:
            return state;
    }
};

